module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-scale-transition', [_c('v-card', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.value),
      expression: "value"
    }],
    attrs: {
      "flat": "",
      "color": _vm.$store.getters.isDarkTheme ? 'grey darken-4' : 'grey lighten-4'
    }
  }, [_c('v-toolbar', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "color": ("green " + (_vm.$store.getters.isDarkTheme ? 'darken-2' : 'lighten-2'))
    },
    on: {
      "click": function($event) {
        _vm.collapsed = !_vm.collapsed
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('buffer-icon', {
    staticStyle: {
      "font-size": "24px"
    }
  })], 1), _vm._v(" "), _c('v-toolbar-title', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t('_busquedas.buffer')))]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "py-0"
  }, [_c('v-slider', {
    staticClass: "pt-0",
    attrs: {
      "min": _vm.min,
      "max": _vm.max,
      "step": _vm.step,
      "thumb-label": true,
      "hide-details": ""
    },
    model: {
      value: (_vm.bufferDistance),
      callback: function($$v) {
        _vm.bufferDistance = $$v
      },
      expression: "bufferDistance"
    }
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center px-3",
    attrs: {
      "xs12": ""
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.bufferDistance) + " m")])])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": "",
      "color": "red"
    },
    on: {
      "click": function($event) {
        _vm.$emit('cancel')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('cancelar')))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "green"
    },
    on: {
      "click": _vm.bufferSearch
    }
  }, [_vm._v(_vm._s(_vm.$t('aceptar')))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06951c7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/core/utils/shared-components/buffer-feature.vue
// module id = 1042
// module chunks = 1